export class Practice {
    id: number;
    name: string;
    members:any;
    invitations:any;
    mentor_invitations:any;
    limited:any;
    mentors:any;
    is_bacs_enabled;
    bacsSeats:number;
    deleteLogo:boolean;
    newLogoB64:string;
    newLogoType:string;
    media:any;
    bacsRenewalDate:string;
    constructor(practice?) {
        if (practice) {
            this.id = practice.id;
            this.name = practice.name;
            this.members = practice.members;
            this.invitations = practice.invitations;
            this.mentor_invitations=practice.mentor_invitations;
            this.limited = practice.limited;
            this.mentors=practice.mentors;
            this.is_bacs_enabled=practice.is_bacs_enabled;
            this.bacsSeats=practice.bacs_seats;
            this.media=practice.media;
            this.bacsRenewalDate=practice.bacs_renewal_date;
        }
    }
}